import moment from 'moment';
import { apiInterfaceForJson,apiInterfaceForFormData } from '../common/apiManager';

export const getUnCheckedOrder = (facilities) => {
    return apiInterfaceForJson('/order/v1/getUnCheckedOrder', 'POST', facilities);
};

export const searchOrdersForSelfPayment = (filters) => {
    let from_date = moment(filters.from_date).format('YYYYMMDDHHmmss');
    let to_date = moment(filters.to_date).format('YYYYMMDDHHmmss');

    let filterParams = {
        facility_id: filters.facility_id,
        from_date: from_date,
        to_date: to_date
    };
    if (filters.status_value) {
        filterParams.status_value = filters.status_value;
    }
    if (filters.search_date) {
        filterParams.search_date = filters.search_date;
    }
    if (filters.testIds) {
        filterParams.testIds = filters.testIds;
    }
    return apiInterfaceForJson('/order/v1/filterSelfPayment', 'POST', filterParams);
};

export const searchOrdersOrder = (filters) => {
    let from_date = moment(filters.from_date).format('YYYYMMDDHHmmss');
    let to_date = moment(filters.to_date).format('YYYYMMDDHHmmss');

    let filterParams = {
        facility_id: filters.facility_id,
        from_date: from_date,
        to_date: to_date,
        resultValues: filters.resultValues && filters.resultValues.length ? filters.resultValues : []
    };
    if (filters.filter_by) {
        filterParams.filterBy = filters.filter_by;
    }
    if (filters.testIds) {
        filterParams.testIds = filters.testIds;
    }
    return apiInterfaceForJson('/order/v1/filterOrder', 'POST', filterParams);
};

export const searchOrdersUniversal = (filters) => {
    const filterParams = {
        search_str: filters.searchStr
    };

    return apiInterfaceForJson('/order/v1/filterUniversal', 'POST', filterParams);
};

export const searchOrderUniversalById = (_id) => {
    return apiInterfaceForJson('/order/v1/filterUniversalById', 'POST', { _id: _id });
};

export const searchOrdersReports = (filters) => {
    let from_date = moment(filters.from_date).format('YYYYMMDDHHmmss');
    let to_date = moment(filters.to_date).format('YYYYMMDDHHmmss');

    let filterParams = {
        facility_id: filters.facility_id,
        from_date: from_date,
        to_date: to_date
    };
    if (filters.filter_by) {
        filterParams.filterBy = filters.filter_by;
    }
    if (filters.testIds) {
        filterParams.testIds = filters.testIds;
    }
    return apiInterfaceForJson('/order/v1/filterReports', 'POST', filterParams);
};

export const searchOrdersDashboard = (filters) => {
    let from_date = moment(filters.from_date).format('YYYYMMDDHHmmss');
    let to_date = moment(filters.to_date).format('YYYYMMDDHHmmss');

    let filterParams = {
        facility_id: filters.facility_id,
        from_date: from_date,
        to_date: to_date,
        testIds: filters.testIds
    };
    return apiInterfaceForJson('/order/v1/filterDashboard', 'POST', filterParams);
};

export const searchTopFacilities = (filters) => {
    let from_date = moment(filters.from_date).format('YYYYMMDDHHmmss');
    let to_date = moment(filters.to_date).format('YYYYMMDDHHmmss');

    let filterParams = {
        facility_id: filters.facility_id,
        from_date: from_date,
        to_date: to_date
    };
    return apiInterfaceForJson('/order/v1/filterTopFacilities', 'POST', filterParams);
};

export const getRequisitions = (filters) => {
    let from_date = moment(filters.from_date).format('YYYYMMDDHHmmss');
    let to_date = moment(filters.to_date).format('YYYYMMDDHHmmss');
    let filterParams = {
        facility_id: filters.facility_id,
        from_date: from_date,
        to_date: to_date,
        is_cancel: filters.is_cancel,
        testIds: filters.testIds,
        isIndividualTest: filters.isIndividualTest ? true : false
    };
    return apiInterfaceForJson('/order/v1/getRequisitions', 'POST', filterParams);
};

export const getRequisitionNewSamples = (datefilter) => {
    return apiInterfaceForJson('/order/v1/getRequisitionNewSamples', 'POST', datefilter);
};

export const uploadRequisitionFiles = (formdata,requisitionPdfPath) => {    
    const url = `/order/v1/uploadRequisitionFiles/${encodeURIComponent(requisitionPdfPath)}`;
    return apiInterfaceForFormData(url, 'POST', formdata);
};
export const removeRequisitionFile = (orderId, fileName) => {
    return apiInterfaceForJson('/order/v1/removeRequisitionFile', 'POST', {
        orderId,
        fileName
    });
};

export const generateAiNarrative = (orderId) => {
    return apiInterfaceForJson(`/resultInterpretation/v1/ai_narrative/${orderId}`, "POST", {});
};

export const getAiNarrative = (orderId) => {
    return apiInterfaceForJson(`/resultInterpretation/v1/ai_narrative/${orderId}`, "GET", null);
};

export const bulkApproveReport = (params) => {
    return apiInterfaceForJson('/order/v1/bulk_approve_report', 'POST', params);
};

export const approveReport = (params) => {
    return apiInterfaceForJson('/order/v1/approve_report', 'POST', params);
};

export const markPreliminary = (params) => {
    return apiInterfaceForJson('/order/v1/mark_preliminary', 'POST', params);
};

export const addCorrection = (params) => {
    return apiInterfaceForJson('/order/v1/addCorrection', 'POST', params);
};

export const addCallbackComment = (params) => {
    return apiInterfaceForJson('/order/v1/addCallbackComment', 'POST', params);
};

export const bulkDownloadZipForPDF = (params) => {
    return apiInterfaceForJson('/order/v1/bulk_download_zip_pdf', 'POST', params);
};

export const getPlateList = (params) => {
    return apiInterfaceForJson('/order/v1/get_plate_list', 'POST', params);
};

export const getUserRole = (params) => {
    return apiInterfaceForJson('/order/v1/get_user_role', 'POST', params);
};

export const importSelfPayDocument = (formdata) => {
    return apiInterfaceForFormData('/order/v1/import_self_pay_document', 'POST', formdata);
};

export const searchResultLinksDashboard = (params) => {
    return apiInterfaceForJson('/order/v1/search_result_links_dashboard', 'POST', params);
};

export const serviceConstants = {};


export const getToxReview = (orderId) => {
    return apiInterfaceForJson('/order/v1/tox_review/' + orderId, 'GET', null);
};

export const resendDelivery = (orderId) => {
    return apiInterfaceForJson('/order/v1/resend_delivery', 'POST', { orderId });
};

export const applyToxReview = (orderId) => {
    return apiInterfaceForJson('/order/v1/tox_review/' + orderId + '/apply', 'POST', {});
};

export const getToxReviewQueue = () => apiInterfaceForJson('/order/v1/tox_review_queue', 'GET', null);
export const batchToxReview = (params) => apiInterfaceForJson('/order/v1/tox_review_batch', 'POST', params);
